module.exports = __webpack_public_path__ + "media/components/resources/svgs/ic_check_square-47c8ac13a014b381efbe61ed7f70ab63.svg";